import filterXSS from 'xss';

// taken from https://stackoverflow.com/questions/1500260/detect-urls-in-text-with-javascript
const urlRegex =
  /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

// Internal only, this is not secure to use without getMessageHtmlSanitized
function getMessageHtml(text: string) {
  return text.replaceAll('\n', '<br>').replaceAll(urlRegex, function (url) {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });
}

export function sanitizeHtml(text: string) {
  return filterXSS(text, {
    whiteList: {
      a: ['href', 'target'],
      br: [],
    },
  });
}

export function getMessageHtmlSanitized(text: string) {
  return sanitizeHtml(getMessageHtml(text));
}
